import { render } from "./XIconSolidChartColumn.vue?vue&type=template&id=3e5924df"
import script from "./XIconSolidChartColumn.vue?vue&type=script&lang=js"
export * from "./XIconSolidChartColumn.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidChartColumn.vue"]])

export default __exports__